<div class="maindiv">
    <editform entityName="Mktpproducts" removeReference="S" [userConfig]="userConfig" [tableInformation]="tableInformation" [row]="row" [evento]="evento" [formGroup]="formGroup" [actionList]="actionList" entityDesc="Cadastro de Produtos"></editform>
</div>
  
